import styled from "styled-components";
import { TkaColor } from "@themes/colors";
import { TkaTypography } from "@themes/font-tags";

export const Text = styled.span<{ typography: TkaTypography; tkaColor: TkaColor }>`
	${({ typography }) => typography}
	color: ${({ tkaColor }) => tkaColor.getColor()};
`;
